import jquery from 'jquery';
import 'bootstrap';

import '@fancyapps/fancybox';

import './core/plugins/jquery.menu';
import './core/functions';
import './cookies';
import './elements/search';
import './elements/dropdown-menu';
import './elements/gallery';

window.jQuery = jquery;
window.$ = jquery;
window.jquery = jquery;


